// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.graph_wrapper {
  width: 49%;
  /* display: flex; */
  gap: 10px;
  height: max-content;
}
.table_full_wrapper {
  width: 100%;
}
@media screen and (max-width: 700px) {
  .graph_wrapper {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Admin/AdminFleetDetails/index.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".graph_wrapper {\r\n  width: 49%;\r\n  /* display: flex; */\r\n  gap: 10px;\r\n  height: max-content;\r\n}\r\n.table_full_wrapper {\r\n  width: 100%;\r\n}\r\n@media screen and (max-width: 700px) {\r\n  .graph_wrapper {\r\n    width: 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
